import { gql } from "@apollo/client";

import IOperation from "api/IOperation";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import { AddToCartMutation as AddToCartMutationType, AddToCartMutationVariables } from "gql/types/mutations/AddToCartMutation";

const text = gql`mutation AddToCartMutation($addToCartInput: MutationAddToCartInput!) {
	addToCart(addToCartInput: $addToCartInput) {
		order {
			id
		}
	}
}
`;

const AddToCartMutation: IOperation<AddToCartMutationType, AddToCartMutationVariables> = { text } as any;

export default AddToCartMutation;
